<template>
  <div class="share-btn-box">
    <div 
      class="share-btn" 
      v-bind:class="{ 'disabled': disabled }" 
      @click="shareJob"
      data-toggle="tooltip"
      data-trigger="hover"
      data-placement="bottom"
      v-bind:title="disabled && tooltipText"
    >
      <i class="far fa-share-alt"></i>
      {{ 'Share' | trans }}
    </div>
  </div>
</template>
<script>
import store from './../../mixins/store.mixin';
import user from './../../mixins/user.mixin';
import currentJob from './../../mixins/current_job.mixin';
import {EventBus} from "../../events/event.bus";
import {EVENT_SHARE, EVENT_QR_SHARE} from "../../events/app.events";
import {satGlobals} from "../../../../../../sat/helper/sat-globals";

export default {
  name: "ShareBtn",
  props: {},
  components: {},
  mixins: [
    store,
    currentJob,
    user
  ],
  data() {
    return {
      tooltipText: this.translate('Login is required for this action'),
    };
  },
  mounted: function () {
  },
  created: function () {
  },
  methods: {
    shareJob() {
      if (this.disabled) {
        return;
      }

      EventBus.$emit(EVENT_SHARE, this.currentJob);
    }
  },
  computed: {
    disabled() {
      return this.complete !== true || this.isRegisteredUser !== true;
    }
  }
};
</script>
<style lang="scss">
.share-btn {
  //background: #1266F1;
  border: 2px solid #1266F1;
  color: #1266F1;
  //color: white;
  height: 45px;
  padding: 10px 10px;
  display: flex;
  justify-content: start;
  align-items: center;
  border-radius: 4px;
  gap: 10px;
  font-size: 1rem;
  font-weight: 600;
  cursor: pointer;
  display: inline-flex;

  &:hover {
  }
}

.disabled {
  opacity: .5;
  cursor: not-allowed;
}
</style>
